import { jsx } from 'react/jsx-runtime';
import { forwardRef, useEffect } from 'react';
import { SELECT_SEARCH_DATA_ROLE } from '../../constants/dataRoles.mjs';
import SearchEmptyImpl from '../../SearchEmptyImpl.mjs';
import { useSelectContext, useSelectSearchContext } from '../context.mjs';

const SelectSearchEmpty = forwardRef(
  ({ children, ...props }, ref) => {
    const { onHasEmptyViewChange } = useSelectContext();
    const { renderEmpty, searchValue } = useSelectSearchContext();
    useEffect(() => {
      onHasEmptyViewChange(true);
      return () => {
        onHasEmptyViewChange(false);
      };
    }, [onHasEmptyViewChange]);
    return renderEmpty ? /* @__PURE__ */ jsx("div", { "data-role": SELECT_SEARCH_DATA_ROLE, ref, ...props, children: typeof children === "function" ? children(searchValue) : children ?? /* @__PURE__ */ jsx(SearchEmptyImpl, {}) }) : null;
  }
);

export { SelectSearchEmpty };
//# sourceMappingURL=SearchEmpty.mjs.map
